import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=2da430d3"
import script from "./OverlaySpinner.vue?vue&type=script&lang=ts"
export * from "./OverlaySpinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports